import { ADMIN_CONSOLE_USER_ROLES_CONSTANTS } from "@/admin/constants/AdminConsoleUserRolesConstants/AdminConsoleUserRolesConstants";
import getUserProperties from "@/users/getUserProperties";
import useUser from "@/users/useUser";

const getUserRoleByPriority = (user) => {
  const {
    isAuthorizedDistrictAdmin,
    isAuthorizedPrincipal,
    isAuthorizedTeacher,
  } = getUserProperties(user);
  if (isAuthorizedDistrictAdmin) {
    return ADMIN_CONSOLE_USER_ROLES_CONSTANTS.DISTRICT_ADMIN;
  } else if (isAuthorizedPrincipal) {
    return ADMIN_CONSOLE_USER_ROLES_CONSTANTS.SCHOOL_ADMIN;
  } else if (isAuthorizedTeacher) {
    return ADMIN_CONSOLE_USER_ROLES_CONSTANTS.TEACHER;
  } else {
    return ADMIN_CONSOLE_USER_ROLES_CONSTANTS.STUDENT;
  }
};

/**
 * Use for retrieve a list of user schools per specified role as parameter.
 * @param {string} role required param must be one of district_admin or principal
 * @returns {{id: string, name: string}} a list of schools
 */
const useSchoolsByRole = (role) => {
  const { data: user } = useUser();
  const userRole = role || getUserRoleByPriority(user);

  if (!user || !userRole) return [];
  if (!user[userRole]) return [];
  if (userRole === ADMIN_CONSOLE_USER_ROLES_CONSTANTS.STUDENT) return [];

  const isDistrictAdmin =
    userRole === ADMIN_CONSOLE_USER_ROLES_CONSTANTS.DISTRICT_ADMIN;
  const schools = isDistrictAdmin
    ? user.schools
    : user[userRole]?.school
      ? [user[userRole].school]
      : [];

  return schools
    .map((school) => {
      return {
        name: school.name,
        id: school.id,
        uniqueId: school.unique_id,
      };
    })
    .sort(function sortByNameAsc(a, b) {
      const nameA = a.name.toUpperCase();
      const nameB = b.name.toUpperCase();

      if (nameA > nameB) return 1;
      if (nameA < nameB) return -1;

      return 0;
    });
};

export default useSchoolsByRole;
